import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";
import BannerImg from "../assets/Images/banner-1920x450.png";

import BottomLogoImg from "../assets/Images/bottom-logo.png";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import Aos from "aos";
import "./EfficientArbitrationPage.scss";

const EfficientArbitrationPage = () => {
  const { t } = useTranslation();
  const [modalShow, setModalShow] = useState(false);
  const [modalShowB, setModalShowB] = useState(false);
  const [modalShowC, setModalShowC] = useState(false);
  const [modalShowD, setModalShowD] = useState(false);
  const [modalShowE, setModalShowE] = useState(false);

  useEffect(() => {
    Aos.init({ duration: 3000, startEvent: "scroll" });
  }, []);

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title">
          <h1 className="banner-main-title">
            {t("efficient_arbitration_page_header")}
          </h1>
          <p className="banner-subtitle">
            {t("efficient_arbitration_page_header2")}
          </p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_efficient_arbitration_page_link1")}</Link>
        <span>{t("breadcrumbs_efficient_arbitration_page_span")}</span>
        <Link>{t("breadcrumbs_efficient_arbitration_page_link2")}</Link>
      </Breadcrumbs>
      <main>
        <Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          size="m"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {t("efficient_arbitration_cost_effective")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{t("efficient_arbitration_cost_effective2")}</p>
          </Modal.Body>
        </Modal>
        <Modal
          show={modalShowB}
          onHide={() => setModalShowB(false)}
          size="m"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {t("efficient_arbitration_timesaving")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{t("efficient_arbitration_timesaving2")}</p>
          </Modal.Body>
        </Modal>
        <Modal
          show={modalShowC}
          onHide={() => setModalShowC(false)}
          size="m"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {t("efficient_arbitration_professional")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{t("efficient_arbitration_professional2")}</p>
          </Modal.Body>
        </Modal>
        <Modal
          show={modalShowD}
          onHide={() => setModalShowD(false)}
          size="m"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {t("efficient_arbitration_confidential")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{t("efficient_arbitration_confidential2")}</p>
          </Modal.Body>
        </Modal>
        <Modal
          show={modalShowE}
          onHide={() => setModalShowE(false)}
          size="m"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {t("efficient_arbitration_legally_binding")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{t("efficient_arbitration_legally_binding2")}</p>
          </Modal.Body>
        </Modal>
        <div className="title">
          <div className="text-items text-center">
            <p className="mb-2 text-center">
              {t("efficient_arbitration_subtitle")}
            </p>
            <p className="text-center">
              {t("efficient_arbitration_subtitle2")}
            </p>
          </div>
        </div>
        <div className="images-section">
          <div className="first-imgs">
            <img
              data-aos="fade-right"
              onClick={() => setModalShow(true)}
              src={t("efficient_section_img1")}
              alt=""
            />
            <img
              data-aos="fade-left"
              onClick={() => setModalShowB(true)}
              src={t("efficient_section_img2")}
              alt=""
            />
          </div>
          <div className="second-imgs">
            <img
              data-aos="fade-right"
              onClick={() => setModalShowC(true)}
              src={t("efficient_section_img3")}
              alt=""
            />
            <img
              data-aos="fade-up"
              onClick={() => setModalShowD(true)}
              src={t("efficient_section_img4")}
              alt=""
            />
            <img
              data-aos="fade-down"
              onClick={() => setModalShowE(true)}
              src={t("efficient_section_img5")}
              alt=""
            />
          </div>
        </div>
        <div className="table-section">
          <p className="table-subtitle">
            {t("efficient_arbitration_subtitle3")}
          </p>
          <div className="table-container">
            <div className="comparison-table-wrapper">
              <table className="comparison-table">
                <thead>
                  <tr>
                    <th></th>
                    <th>Efficient Arbitration</th>
                    <th>Traditional Arbitration</th>
                    <th>Court Litigation</th>
                  </tr>
                </thead>
                <tbody >
                  <tr>
                    <td className="row-header">Type of Proceedings</td>
                    <td>Civil</td>
                    <td>Civil</td>
                    <td>Civil and criminal</td>
                  </tr>
                  <tr>
                    <td className="row-header">
                      How Arbitrator/Judge is selected
                    </td>
                    <td>Parties select Arbitrator</td>
                    <td>Parties select Arbitrator</td>
                    <td>Court appoints Judge - parties have limited input</td>
                  </tr>
                  <tr>
                    <td className="row-header">Appeal available</td>
                    <td>Final & Binding</td>
                    <td>Final & Binding</td>
                    <td>Appeal possible</td>
                  </tr>
                  <tr>
                    <td className="row-header">Costs</td>
                    <td>Fixed Fee</td>
                    <td>Expensive and unpredictable</td>
                    <td>Expensive and unpredictable</td>
                  </tr>
                  <tr>
                    <td className="row-header">Attendance for Hearing</td>
                    <td>Once</td>
                    <td>One or more hearings</td>
                    <td>Many times</td>
                  </tr>
                  <tr>
                    <td className="row-header">Time duration for Hearing</td>
                    <td>One Day</td>
                    <td>From a few days to a few months</td>
                    <td>From few days to months</td>
                  </tr>
                  <tr>
                    <td className="row-header">
                      Time for arranging to resolve a dispute
                    </td>
                    <td>Three months</td>
                    <td>From a few months to a few years</td>
                    <td>From one year to few years</td>
                  </tr>
                  <tr>
                    <td className="row-header">Confidentiality</td>
                    <td>Private</td>
                    <td>Private</td>
                    <td>Public - in Court - disclosed to the public</td>
                  </tr>
                  <tr>
                    <td className="row-header">Resolution Result</td>
                    <td>
                      Private - only between parties in written Arbitral Awards
                    </td>
                    <td>
                      Private - only between parties in written Arbitral Awards
                    </td>
                    <td>Public - disclosed to the public</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </main>
      <div className="temporary">
        <img id="res-img" src={BottomLogoImg} alt="" />
      </div>
      <Footer />
    </>
  );
};

export default EfficientArbitrationPage;
